<template>
    <select :disabled="readonly" v-model="displayValue" class="form-control">
        <option v-for="sn in years" :value="sn" v-bind:key="sn">{{ sn }}</option>
    </select>
</template>
<script>
export default {
    props: {
        value: {
            default: null
        },
        readonly: {
            default: false
        }
    },
    computed: {
        years: () => {
            let data = new Date();
            return [
                data.getFullYear() - 2,
                data.getFullYear() - 1,
                data.getFullYear(),
                data.getFullYear() + 1
            ];
        },
        displayValue: {
            get: function() {
                return this.value;
            },
            set: function(modifiedValue) {
                this.$emit("input", modifiedValue);
            }
        }
    }
};
</script>
